import { LockScroll } from "./LockScroll.js";

export class Menu {
    constructor() {
        this.menuFlag = false;
        this.lockScroll = new LockScroll();

        this.bindEvents();
        this.bindDataPolicy();
    }

    open() {
        if (this.menuFlag) {
            return;
        }
        this.menuFlag = true;

        if (App.formIsOpen) {
            App.W.trigger("form:close");
        }

        App.H.addClass("_menu-open");

        setTimeout(() => {
            this.lockScroll.lock();
        }, 500);

        setTimeout(() => {
            this.menuFlag = false;
        }, 1000);

        App.menuIsOpen = true;

        // Ставим фокус на первую ссылку (для Tab-навигации)
        if (!App.mobile) {
            setTimeout(() => {
                $(".js-menu").find("a:eq(0)").focus();
            }, 1000);
        }
    }

    close() {
        if ($(".js-data-policy").length) {
            $(".js-data-policy").removeClass("_open");
        }

        if (this.menuFlag) return;
        this.menuFlag = true;

        App.H.removeClass("_menu-open");

        this.lockScroll.unlock();

        setTimeout(() => {
            this.menuFlag = false;
        }, 300);

        setTimeout(() => {
            this.menuFlag = false;
        }, 1000);

        App.menuIsOpen = false;

        // Возвращаем фокус на бургер (для Tab-навигации)
        if (!App.mobile) {
            $(".js-burger").focus();
        }
    }

    bindEvents() {
        $(".js-open-menu").on("click", () => {
            if (this.menuFlag) {
                return;
            }

            if (App.menuIsOpen) {
                this.close();
            } else {
                this.open();
            }
        });

        $(".js-close-menu").on("click", () => {
            this.close();
        });

        App.W.on("menu:close", () => {
            this.close();
        });

        // Закрыть меню клавишей Escape
        App.W.on("keydown.menu", (e) => {
            if (App.menuIsOpen && e.keyCode == 27) {
                this.close();
            }
        });
    }

    bindDataPolicy() {
        // Открыть подробности политики о персональных данных
        $(".js-open-data-policy").on("click", (e) => {
            e.preventDefault();
            $(".js-data-policy").addClass("_open");
            $(".js-data-policy")
                .find(".js-email-in-policy")
                .attr("href", "mailto:info@cpeople.ru");
            $(".js-data-policy")
                .find(".js-email-in-policy")
                .text("info@cpeople.ru");
        });

        $(".js-close-data-policy").on("click", () => {
            $(".js-data-policy").removeClass("_open");
        });
    }
}

let menu;

App.W.on("barba:afterEnter", () => {
    menu = new Menu();
});

App.W.on("barba:leave", () => {
    try {
        menu.destroy();
    } catch (error) {}
});

// открываем форму если есть #form в url
if (window.location.hash === "#form") {
    App.W.on("barba:afterEnter", () => {
        // $(".js-open-menu").trigger("click");
        App.H.removeClass("_menu-open");
        setTimeout(() => {
            $(".js-open-form").trigger("click");
        }, 50);
    });
}



// WEBPACK FOOTER //
// ./_src/js/modules/Menu.js